import styled from 'styled-components'

import { colors } from '../../styles/colors'

export const SwitchInput = styled.input`
  height: 0;
  width: 0;
  visibility: hidden;
`

export const SwitchLabel = styled.label<{ checked: boolean; large: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: ${({ large }) => (large ? '121' : '86')}px;
  height: 28px;
  border-radius: 18px;
  background-color: ${({ checked }) =>
    checked ? `${colors.green}` : `${colors.gray}`};
  position: relative;
`

export const SwitchButton = styled.span`
  content: '';
  position: absolute;
  top: 1px;
  left: 1px;
  bottom: 0px;
  right: 1px;
  width: 24.32px;
  height: 24.5px;
  border-radius: 50%;
  transition: 0.2s;
  background: ${colors.white};
  box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
  ${SwitchInput}:checked + ${SwitchLabel} & {
    left: calc(100% - 2px);
    transform: translateX(-100%);
  }

  ${SwitchLabel}:active & {
    width: 45px;
  }
`

export const SwitchTitle = styled.span<{ checked: boolean }>`
  color: ${colors.white};
  font-size: 12px;
  font-weight: 700;
  margin-left: ${({ checked }) => (checked ? '15' : '35')}px;
`
